import isDev from '@utils/env/is-dev';
import isServer from '@utils/env/is-server';
import getNodeAegis from '@utils/async-module/get-node-aegis';
import isTencentSecurityScan from '@utils/security/is-tencent-security-scan';
import cookies from 'next-cookies';
let nodeAegis: any;

export const initNodeAegis = async (ctx: any) => {
  if (nodeAegis) {
    return;
  }
  const allCookies = cookies(ctx || {});
  const uin = allCookies.app_uid || '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { default: Aegis } = await getNodeAegis();
  nodeAegis = new Aegis({
    id: isDev || process.env.TEST_ENV ? 'ebsNQtbXomPmvNrlMi' : 'ebsNQtbXkeAuOmGxcP', // 项目ID
    uin, // 用户唯一 ID（可选）
    selector: {
      type: isDev ? 'host' : 'polaris',
    },
    // 先用这个字段来填 referer
    ext2: ctx?.req?.headers.referer,
    // 先用这个字段来填 ua
    ext3: ctx?.req?.headers['user-agent'],
  });
  console.log('inited nodeAegis------');
};

// 设置用户标示
export const setAegisUin = async (ctx: any, customUin?: string) => {
  const allCookies = cookies(ctx || {});
  const uin = allCookies.app_uid || customUin || '';
  if (!nodeAegis) {
    await initNodeAegis(ctx);
  }
  if (uin) {
    nodeAegis?.setConfig({
      // @ts-ignore
      ext3: BUILD_TIME || '0.0.1',
      uin,
    });
  }
};

/**
 * 白名单日志上报
 * @param msg
 * @param ctx
 */
export const nodeAegisInfo = async (msg: string, ctx: any) => {
  if (!isServer || isTencentSecurityScan(ctx)) {
    return;
  }
  if (!nodeAegis) {
    await initNodeAegis(ctx);
  }
  setAegisUin(ctx);
  nodeAegis.info(msg);
};

/**
 * 全量日志上报
 * @param msg
 * @param ctx
 */
export const nodeAegisInfoAll = async (msg: string, ctx: any) => {
  // console.log('ctx', ctx?.req);
  if (!isServer || !ctx || isTencentSecurityScan(ctx)) {
    return;
  }
  if (!nodeAegis) {
    await initNodeAegis(ctx);
  }
  console.log('nodeAegisInfoAll:', msg);
  setAegisUin(ctx);
  nodeAegis.infoAll(msg);
};

/**
 * 上报接口错误
 * @param msg
 * @param ctx
 */
export const nodeAegisReportError = async (msg: string, ctx: any) => {
  if (!isServer || isTencentSecurityScan(ctx)) {
    return;
  }
  if (!nodeAegis) {
    await initNodeAegis(ctx);
  }
  setAegisUin(ctx);
  nodeAegis.infoAll(msg);
};

/**
 * 上报统计
 * @param key
 * @param ctx
 */
export const nodeAegisReportEvent = async (key: string, ctx: any) => {
  if (!isServer || isTencentSecurityScan(ctx)) {
    return;
  }
  if (!nodeAegis) {
    await initNodeAegis(ctx);
  }
  setAegisUin(ctx);
  nodeAegis.reportEvent(key);
};

/**
 * 测速打点开始
 * @param key
 * @param ctx
 */
export const nodeAegisTime = async (key: string, ctx: any) => {
  if (!isServer || isTencentSecurityScan(ctx)) {
    return;
  }
  if (!nodeAegis) {
    await initNodeAegis(ctx);
  }
  setAegisUin(ctx);
  nodeAegis.time(key);
};

/**
 * 测速打点结束
 * @param key
 * @param ctx
 */
export const nodeAegisTimeEnd = async (key: string, ctx: any) => {
  if (!isServer || isTencentSecurityScan(ctx)) {
    return;
  }
  if (!nodeAegis) {
    await initNodeAegis(ctx);
  }
  setAegisUin(ctx);
  nodeAegis.timeEnd(key);
};

/**
 * 测速上报
 * @param key
 * @param ctx
 */
export const nodeAegisReportTime = async (key: string, time: number, ctx: any) => {
  if (!isServer || isTencentSecurityScan(ctx)) {
    return;
  }
  if (!nodeAegis) {
    await initNodeAegis(ctx);
  }
  setAegisUin(ctx);
  nodeAegis.reportTime(key, time);
};

export default nodeAegisInfoAll;
